package dev.danko.roblox_craft_ai.state

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import kotlinx.browser.localStorage

object UiModeController {
    private const val STORAGE_KEY = "robloxCraft.simpleMode"

    var simpleMode: Boolean by mutableStateOf(loadSimpleMode())
        private set

    fun toggle() {
        simpleMode = !simpleMode
        runCatching { localStorage.setItem(STORAGE_KEY, simpleMode.toString()) }
    }

    private fun loadSimpleMode(): Boolean =
        runCatching { localStorage.getItem(STORAGE_KEY) }.getOrNull()?.toBooleanStrictOrNull() ?: true
}
